// removed by extract-text-webpack-plugin
module.exports = {"starPicker":"_37iA7","light":"_1nbAe"};


//////////////////
// WEBPACK FOOTER
// ./app/components/StarPicker/StarPicker.scss
// module id = 909
// module chunks = 34